import type { I18n } from 'domains/application/i18n.types'

const config: I18n =
  __IS_SERVER__ !== true ? (__APP__.i18n as unknown as I18n) : ({} as I18n)

export function setConfig(newConfig: Record<keyof I18n, string>) {
  const keys = Object.keys(newConfig)

  keys.forEach((k) => (config[k as keyof I18n] = newConfig[k as keyof I18n]))
}
export default config
